import { render, staticRenderFns } from "./GroupActionDialog.vue?vue&type=template&id=4c96d408&"
import script from "./GroupActionDialog.vue?vue&type=script&lang=js&"
export * from "./GroupActionDialog.vue?vue&type=script&lang=js&"
import style0 from "./GroupActionDialog.vue?vue&type=style&index=0&id=4c96d408&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports